/**
 * Класс AbstractOperationResult определяет структуру результата геометрической операции
 */
class AbstractGeometryOperationResult {
  /**
   * Создание экземпляра класса AbstractGeometryOperationResult
   * @param {object} params
   * @param {object} params.features - объекты, удовлетворяющие результатам операции (исходные)
   * @param {object} params.geometry - результирующая геометрия
   * @param {object} params.geometryCollection - коллекция результирующих геометрий
   */
  constructor(params) {
    this.type = "abstractGeometryOperationResult";
    this.feature = params.feature;
    this.features = params.features;
    this.geometry = params.geometry;
    this.geometryCollection = params.geometryCollection;
  }
}

module.exports = AbstractGeometryOperationResult;